<!--
 * @Author: xbxie xbxie@iflytek.com
 * @Date: 2022-06-28 14:37:55
 * @LastEditors: xbxie xbxie@iflytek.com
 * @LastEditTime: 2022-06-28 14:43:03
 * @FilePath: \ifly-mall-lsd-web\src\components\common\CustomerService.vue
 * @Description: 客服弹窗
-->
<template>
  <div v-show="visible" class="customer-service">
    <i class="close el-icon-close" @click="$emit('update:visible', false)"></i>
    <iframe src="https://xffk.iflytek.com/pc/#/?configId=1656053249431" class="iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="less" scoped>
.customer-service {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 640px;
  height: 460px;
  z-index: 100;
  display: block;
  background: rgb(255, 255, 255);
  border-radius: 24px;
  .close {
    position: absolute;
    z-index: 1;
    right: 6px;
    top: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #fff;
  }
  .iframe {
    width: 640px;
    height: 460px;
    border: none;
  }
}
</style>
